import {type ProjectTemplate} from '../types.js'

const blogTemplate: ProjectTemplate = {}

export default blogTemplate
